import { render, staticRenderFns } from "./RoleFormModal.vue?vue&type=template&id=51935066&scoped=true"
import script from "./RoleFormModal.vue?vue&type=script&lang=js"
export * from "./RoleFormModal.vue?vue&type=script&lang=js"
import style0 from "./RoleFormModal.vue?vue&type=style&index=0&id=51935066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51935066",
  null
  
)

export default component.exports